export default __webpack_public_path__ + "images/I7.cbacd5d.png";